/* 
Importing dependencies
*/
import * as service from "./FileExplorer.service.js";
// import { Storage } from "firebase/storage";
// import { storage } from "../../config/firebase";
// import { Storage } from "@google-cloud/storage";

export default {
  data: () => ({
    open: ["public"],
    files: {
      html: "mdi-language-html5",
      js: "mdi-nodejs",
      json: "mdi-json",
      md: "mdi-markdown",
      pdf: "mdi-file-pdf",
      png: "mdi-file-image",
      txt: "mdi-file-document-outline",
      xls: "mdi-file-excel"
    },
    tree: [],
    active: [],
    Attachments: [],
    items: [
      {
        name: "Jackson",
        children: [],
        id: "Jackson/"
      }
    ]
  }),
  computed: {
    // items() {
    //   return [
    //     {
    //       name: "Jackson",
    //       children: this.Attachments,
    //       id: "Jackson/"
    //     }
    //   ];
    // },
    selected() {
      if (!this.active.length) return undefined;

      const selectedfile = this.active[0];

      if (!selectedfile.file) return undefined;

      return selectedfile;
    }
  },
  methods: {
    async fetchFiles(item) {
      let response = await service.GetChildnodes(item);

      let result = JSON.parse(response.data);

      result.forEach(attachment => {
        if (attachment.file != null) {
          const newAttachment = {
            name: attachment.name,
            file: attachment.file,
            id: attachment.id,
            url: attachment.url
          };

          item.children.push(newAttachment);
        } else {
          const newAttachment = {
            name: attachment.name,
            children: [],
            id: attachment.id,
            url: attachment.url
          };

          item.children.push(newAttachment);
        }
      });

      //item.children = result;
      //this.Attachments.push(result.data);
      //console.log(this.items);
      //console.log(this.x);
    },
    addChild(item) {
      if (!item.children) {
        this.$set(item, "children", []);
      }

      const name = `${item.name} (${item.children.length})`;
      const id = this.nextId++;
      item.children.push({
        id,
        name
      });
    }
  }
};
